import { isSupported } from './video-embed';

const textEditorVideoEmbedFormSettings = {
  form: 'text-editor-video-embed',
  fields: ['url'],
  validate: values => {
    const errors = {};
    const { url } = values;

    if (!url) {
      errors.url = 'required';
    } else if (!isSupported(url)) {
      errors.url = 'not-supported';
    }

    return errors;
  },
};

export default textEditorVideoEmbedFormSettings;



// WEBPACK FOOTER //
// ./app/services/text-editor-video-embed-form-settings.js